export default "__VITE_ASSET__c4a988b5__"